export const raceItemId = vhiko => `race_${vhiko}`

export const productItemId = pid => `product_${pid}`

export const eventCategory2 = eseko => `event_${eseko}`

export const pushEcommerceEvent = payload => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ ecommerce: null })
  window.dataLayer.push(payload)
}
